module.exports = __webpack_public_path__ + "static/media/tcs2.001dac8b.png";